import { Button, message } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { overseaTranslate } from 'services/api/overseaTranslate';
import { useTranslate } from '@tolgee/react';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';

function useTextsTranslate(texts: string[]) {
  const { t } = useTranslate();

  const sysLang = useSystemLanguageValue();

  const [translating, setTranslating] = useState(false);

  const [showTranslate, setShowTranslate] = useState(true);

  const [result, setResult] = useState<Partial<Record<string, string>>>();

  const translate = useCallback(
    ({ texts, sysLang }: { texts: string[]; sysLang: General.SystemLanguage }) => {
      if (!texts.length) {
        return;
      }

      setTranslating(true);

      return overseaTranslate(texts, sysLang, 'review')
        .then((res) => {
          setResult(
            res.reduce<Partial<Record<string, string>>>((res, cur, index) => {
              res[texts[index]] = cur;
              return res;
            }, {}),
          );
        })
        .catch(() => {
          message.error(t('phrase.翻译失败'));
        })
        .finally(() => {
          setTranslating(false);
        });
    },
    [t],
  );

  useEffect(() => {
    if (showTranslate && (sysLang === 'zh-CN' || sysLang === 'en-US')) {
      translate({
        texts,
        sysLang,
      });
    }
  }, [translate, texts, sysLang, showTranslate]);

  const trigger = (
    <Button type="link" loading={translating} onClick={() => setShowTranslate(!showTranslate)}>
      {showTranslate ? t('trade.查看原文') : t('trade.查看翻译')}
    </Button>
  );

  return {
    showTranslate,
    trigger,
    result,
    t,
  };
}

export default useTextsTranslate;
